import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import QuestionSection from "Components/Utilities/QuestionSection";

import AgendaIndex2 from 'Pages/Agenda/index2';

import { asset } from "Services/BaseHelpers";

export default class Activities extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <Authenticated title="Dashboard">
                <PageHeader
                   title={"Optional Activities"}
                   imgSrc={'programme-hero.png'}
                />
                {this.renderOptionalActivitiesSection()}
                {this.renderRobinIslandSection()}
                {this.renderTableMountainSection()}
                {this.renderCapePointSection()}
                {this.renderCatamaranTourSection()}
                {this.renderEBikeSection()}
                {this.renderHikingSection()}
                {this.renderHIBSection()}

                <QuestionSection />
            </Authenticated>
        );
    }

    /**
     * @method renderOptionalActivitiesSection
     * @return {*}
     */
    renderOptionalActivitiesSection () {
        return (
            <Section>
                <p className={"bmw-condenced-bold text-2xl"}>
                    OPTIONAL ACTIVITIES
                </p>
                <p className={"bmw-condenced-bold"}>
                    During your time in Cape Town, you’ll get the chance to take part in an activity of your choice.
                    Whether you’re seeking culture, adventure, adrenaline, or simply just want to take in the famous sights,
                    there is something for everyone. Have a read through the activity information to help you choose:
                </p>
            </Section>
        )
    }

    /**
     * @method renderRobinIslandSection
     * @return {*}
     */
    renderRobinIslandSection () {
        return (
            <Section>
                <p className={"p-5 bmw-condenced-bold text-2xl uppercase"}>
                    Robben ISLAND TOUR
                </p>

                <img className={"mx-auto my-auto"} src={ asset ( 'images/robin_island.png' ) } />

                 <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 text-left"}>
                     <div>
                         <p className={"p-4 bmw-light"}>
                             Robben Island was home to a Maximum Security Prison which housed the late freedom fighter, former South African president
                             and noble prize winner, Nelson Mandela, where he was imprisoned for 18 years. It is now a South African National Heritage Site
                             and a UNESCO World Heritage Site.
                         </p>
                         <p className={"p-4 bmw-light"}>
                             On this tour you will travel by boat trip over to the island, taking in the stunning views across the bay with Table Mountain as a backdrop.
                             You’ll explore the island and learn about its rich history  and the notoriously tough conditions those imprisoned here faced on a daily basis.
                         </p>

                         <p className={"p-4 bmw-light"}>
                             You’ll have your own private guide, Christo Brand, to share the island’s history with you.
                             Christo became a guard to Mandela on the Island at aged just 19 and developed a close friendship with him the course of many years.
                             Christo retired from Robben Island in 2018.
                         </p>
                     </div>
                     <div>
                        <p className={"bmw-bold p-4"}>
                             Timings
                         </p>
                         <p className={"px-4 bmw-light"}>
                            The first tour will depart hotels at 08:30 and return at 14:00.
                         </p>
                         <p className={"p-4 bmw-light"}>
                            The second tour will depart hotels at 11:30 and return at 16:30.
                         </p>
                         <p className={"p-4 bmw-light"}>
                            Tour times are fixed and subject to availability and demand.
                         </p>
                         <p className={"bmw-bold p-4"}>
                             Other information:
                         </p>
                         <p className={"px-4 bmw-light"}>
                             This tour is suitable for all abilities.
                         </p>
                         <p className={"px-4 bmw-light"}>
                             We advise ensuring you have a provision of seasickness tablets for the boat journey if required.
                         </p>
                         <p className={"p-4 bmw-light"}>
                             Your tour will also include a private lunch at the Waterfront’s famous Sevruga restaurant,
                             offering a delectable menu of seafood and grilled meats infused with Asian flavours.
                         </p>
                     </div>
                 </div>
            </Section>
        )
    }

    /**
     * @method renderTableMountainSection
     * @return {*}
     */
    renderTableMountainSection () {
        return (
            <Section>
                <p className={"p-5 bmw-condenced-bold text-2xl"}>
                    TABLE MOUNTAIN
                </p>

                <img className={"mx-auto my-auto"} src={ asset ( 'images/table_mountain.png' ) } />

                 <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 text-left"}>
                     <div>
                         <p className={"p-4 bmw-light"}>
                            Table Mountain is Cape Town’s most popular attraction and a must for first time visitors to the city.
                             In 2011 it was voted as one of the New 7 Wonders of Nature by over 1 million voters.
                             Its most distinctive feature is its flat tabletop, formed millions of years ago during an ice age.
                         </p>

                         <p className={"p-4 bmw-light"}>
                             You’ll head up the mountain via a 5-minute ride cable car ride. When you reach the top, marvel at the amazing 360 views of the city or explore
                             the park for unique wild life and nature. Escape the crowds and enjoy refreshments on our own private terrace before returning
                             back down in the cable car.
                         </p>

                         <p className={"p-4 bmw-light"}>
                            There is something for everyone to enjoy at Table Mountain, from guided walks to adrenaline-inducing hikes and abseiling.
                             The cable car is a fan-favourite and every year thousands of tourists take this spectacular 5-minute ride to the top of Table Mountain.
                         </p>
                     </div>
                     <div>
                        <p className={"bmw-bold p-4"}>
                             Timings
                         </p>

                         <p className={"px-4 bmw-light"}>
                            The tour will depart hotels at 10:30am and return by 14:00.
                         </p>

                         <p className={"bmw-bold p-4"}>
                             Other information:
                         </p>

                         <p className={"px-4 bmw-light"}>
                             This tour is suitable for all abilities.
                         </p>

                         <p className={"px-4 bmw-light"}>
                            Lunch at an exclusive location will be included after the activity, before returning to hotels
                         </p>
                     </div>
                 </div>
            </Section>
        )
    }

    /**
     * @method renderCapePointSection
     * @return {*}
     */
    renderCapePointSection () {
        return (
            <Section>
                <p className={"p-5 bmw-condenced-bold text-2xl"}>
                    CAPE POINT TOUR
                </p>

                <img className={"mx-auto my-auto"} src={ asset ( 'images/cape_point.png' ) } />

                 <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 text-left"}>
                     <div>
                         <p className={"p-4 bmw-light"}>
                             Chapman’s Peak Drive on the Atlantic Coast between Hout Bay and Noordhoek in the Cape Peninsula is one of the most spectacular
                             marine drives in the world. Affectionately known as “Chappies” it is a must for anyone who is passionate about the
                             majestic scenery of Cape Town.
                         </p>

                         <p className={"bmw-bold p-4"}>
                             Cape of Good Hope:
                         </p>

                         <p className={"p-4  bmw-light"}>
                            A World Heritage Site, and protected Nature Reserve is an area of vast natural beauty, world renown for it natural vegetation and rich bio-diversity.
                         </p>

                        <p className={"bmw-bold p-4"}>
                             Chapman’s Peak Drive:
                         </p>

                         <p className={"px-4 bmw-light"}>
                             Chapman’s Peak Drive on the Atlantic Coast between Hout Bay and Noordhoek in the Cape Peninsula is one of the most spectacular marine drives in the world. Chapman’s
                             Peak Drive is affectionately known as “Chappies” and is a must for anyone who is passionate about the majestic scenery of Cape Town.
                         </p>
                     </div>
                     <div>
                         <p className={"bmw-bold p-4"}>
                             Boulders Beach Penguin Colony:
                         </p>

                         <p className={"px-4  bmw-light"}>
                             Boulders Beach is a sheltered beach made up of inlets between granite boulders, from which the name originated.
                             It’s home to the famous African Penguins colony, distinctive because of the sound they make.
                             Colonies can be found from southern Namibia and along the South African coast but few places offer as remarkable a viewing point as Boulders Beach.
                         </p>

                        <p className={"bmw-bold p-4"}>
                             Timings
                         </p>

                         <p className={"px-4 bmw-light"}>
                             Tours will depart hotels at 09:00 and return at 14:30.
                         </p>

                         <p className={"bmw-bold p-4"}>
                             Other information:
                         </p>

                         <p className={"px-4 bmw-light"}>
                             This tour is suitable for all abilities.
                         </p>

                         <p className={"p-4 bmw-light"}>
                             You’ll enjoy a lunch at an exclusive coastal location before returning back to your hotel.
                         </p>
                     </div>
                 </div>
            </Section>
        )
    }

    /**
     * @method renderCatamaranTourSection
     * @return {*}
     */
    renderCatamaranTourSection () {
        return (
            <Section>
                <p className={"p-5 bmw-condenced-bold text-2xl"}>
                    CATAMARAN CRUISE
                </p>

                <img className={"mx-auto my-auto"} src={ asset ( 'images/catamaran_cruise.png' ) } />

                 <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 text-left"}>
                     <div>
                         <p className={"p-4 bmw-light"}>
                             Once described by Sir Francis Drake as “the fairest Cape in all the World” you’ll get to witness the stunning cape coastline from the water whilst
                             enjoying a few hours of relaxation. Departing from the V&A waterfront, you’ll set sail on a private catamaran allowing you to soak up the
                             sights whilst experiencing 5-star service. Drinks and lunch are served on board, and you can even opt for a dip in the ocean!
                         </p>
                     </div>
                     <div>
                        <p className={"bmw-bold p-4"}>
                             Timings
                         </p>

                         <p className={"px-4 bmw-light"}>
                            This tour will depart hotels at 11:00 and return at 14:30.
                         </p>

                         <p className={"bmw-bold p-4"}>
                             Other information:
                         </p>

                         <p className={"p-4 bmw-light"}>
                             This tour is suitable for all abilities. Life jackets are available if required.
                         </p>

                         <p className={"p-4 bmw-light"}>
                             Lunch is included on board the catamaran.
                         </p>
                     </div>
                 </div>
            </Section>
        )
    }

    /**
     * @method renderEBikeSection
     * @return {*}
     */
    renderEBikeSection () {
        return (
            <Section>
                <p className={"p-5 bmw-condenced-bold text-2xl"}>
                    E-BIKE TOUR
                </p>

                <img className={"mx-auto my-auto"} src={ asset ( 'images/e_bike.png' ) } />

                 <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 text-left"}>
                     <div>
                         <p className={"p-4 bmw-light"}>
                             Experience the natural surroundings of the Tokai Forest alongside the adrenaline rush of riding an E-bike.
                             This majestic forest is home to over 110 plant species that are threatened with extinction or extinct in the wild and
                             have been restored at Tokai which makes this a truly special experience.
                         </p>
                         <p className={"p-4 bmw-light"}>
                             As the trails have extended and adapted over the years, Tokai has become a destination in its own right amongst avid bikers, tourists and the local community.
                         </p>
                     </div>
                     <div>
                        <p className={"bmw-bold p-4"}>
                             Timings
                         </p>
                         <p className={"px-4 bmw-light"}>
                            This tour will depart hotels at 10:00 and return at 14:30.
                         </p>
                         <p className={"bmw-bold p-4"}>
                             Other information:
                         </p>
                         <p className={"px-4 bmw-light"}>
                             This tour is suitable for all abilities.
                         </p>
                         <p className={"p-4 bmw-light"}>
                             Helmets and E-bikes are provided.
                         </p>
                         <p className={"p-4 bmw-light"}>
                             Lunch at an exclusive location will be included after the activity, before returning to hotels.
                         </p>
                     </div>

                 </div>
            </Section>
        )
    }

    /**
     * @method renderHikingSection
     * @return {*}
     */
    renderHikingSection () {
        return (
            <Section>
                <p className={"p-5 bmw-condenced-bold text-2xl"}>
                    HIKING
                </p>
                <img className={"mx-auto my-auto"} src={ asset ( 'images/hiking.png' ) } />
                <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 text-left"}>
                    <div>
                        <p className={"p-4 bmw-light"}>
                            A unique encounter with nature through a guided hike along the foot of Cape Town’s famous Table Mountain.
                        </p>
                        <p className={"p-4 bmw-light"}>
                            Take in the amazing scenery and learn about the city history and indigenous vegetation from your expert guides.
                            Route distances will depending on interest and ability and will cover a minimum of 5km.
                        </p>
                     </div>
                     <div>
                        <p className={"bmw-bold p-4"}>
                             Timings
                         </p>
                         <p className={"px-4 bmw-light"}>
                            This tour will depart hotels at 10:00 and return at 14:00
                         </p>
                         <p className={"bmw-bold p-4"}>
                             Other information:
                         </p>
                         <p className={"px-4 bmw-light"}>
                             This tour is suitable for all abilities.
                         </p>
                         <p className={"p-4 bmw-light"}>
                             Lunch at an exclusive location will be included after the activity, before returning to hotels.
                         </p>
                     </div>
                 </div>
            </Section>
        )
    }

    /**
     * @method renderHIBSection
     * @return {*}
     */
    renderHIBSection () {
        return (
            <Section>
                <p className={"p-5 bmw-condenced-bold text-2xl"}>
                    RIB BOATS
                </p>

                <img className={"mx-auto my-auto"} src={ asset ( 'images/powerboat.png' ) } />

                 <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 text-left"}>
                     <div>
                         <p className={"p-4 bmw-light"}>
                             With the wind in your hair, the spray of the cold Atlantic Ocean on your face, and a magnificent mountainous backdrop,
                             the sparkling blue water of Hout Bay is home to this thrilling experience around the Cape’s unspoilt coastline.
                         </p>
                         <p className={"p-4 bmw-light"}>
                             Zip through the water in a Rigid-hulled Inflatable Boat – a combination of power and exploration as you cruise
                             the Atlantic coastline to view the spectacular sea and birdlife, under the guidance of highly experienced skippers.
                         </p>
                     </div>
                     <div>
                        <p className={"bmw-bold p-4"}>
                             Timings
                         </p>
                         <p className={"bmw-light px-4"}>
                            This tour will depart hotels at 09:30 and return at 14:00.
                         </p>
                         <p className={"bmw-bold p-4"}>
                             Other information:
                         </p>
                         <p className={"px-4 bmw-light"}>
                             This activity is not recommended if you have any back, knee or neck injuries or operations.
                         </p>
                         <p className={"p-4 bmw-light"}>
                            Life jackets will be provided.
                         </p>
                         <p className={"p-4 bmw-light"}>
                            Lunch at an exclusive location will be included after the activity, before returning to hotels.
                         </p>
                     </div>

                 </div>
            </Section>
        )
    }

}
